// order is important see Error404
export const layoutRoutingUrls = {
    tcAdmin: '/tc-admin',
    admin: '/admin',
    user: '/',
};
